<mat-card class="product-card">
  <mat-card-content>
    <nav mat-tab-nav-bar class="navigation-tabs">
      <a
        mat-tab-link
        [routerLink]="['./general']"
        routerLinkActive
        #general="routerLinkActive"
        [active]="general.isActive"
      >
        {{ 'labels.heading.General' | translate }}
      </a>
      <ng-container *ngFor="let recurringDepositDatatable of recurringDepositDatatables">
        <a
          mat-tab-link
          [routerLink]="['./datatables', recurringDepositDatatable.registeredTableName]"
          routerLinkActive
          #datatable="routerLinkActive"
          [active]="datatable.isActive"
          *mifosxHasPermission="'READ_' + recurringDepositDatatable.registeredTableName"
        >
          {{ recurringDepositDatatable.registeredTableName }}
        </a>
      </ng-container>
    </nav>

    <router-outlet></router-outlet>
  </mat-card-content>
</mat-card>
